import { ScreenBuildingDetail } from '@dms/screen'

// export { getServerSideProps } from '@dms/screen/location/list'

export default ScreenBuildingDetail
